const MAP_STYLE_NAJM = [
  /* === GLOBAL === */
  {
    elementType: "geometry",
    stylers: [{ color: "#f9f6f7" }]
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#79445b" }]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#f9f6f7" }]
  },

  /* === WATER === */
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#b497a4" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#5e3447" }]
  },

  /* === GREEN AREAS === */
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#d0bec6" }]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#d0bec6" }]
  },

  /* === ROADS === */
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#dfd3d8" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#79445b" }]
  },

  /* === HIGHWAYS === */
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#af8f9d" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#8f6376" }]
  },

  /* === POI === */
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#eadfe4" }]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#79445b" }]
  },

  /* === ADMIN / BORDERS === */
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{ color: "#c1aab5" }]
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{ color: "#79445b" }]
  },
  /* === SHOPS / BUSINESS === */
  {
    featureType: "poi.business",
    elementType: "geometry",
    stylers: [
      { color: "#eadfe4" }
    ]
  },
  {
    featureType: "poi.business",
    elementType: "labels.text.fill",
    stylers: [
      { color: "#79445b" }
    ]
  },
  {
    featureType: "poi.business",
    elementType: "labels.icon",
    stylers: [
      { saturation: -40 },
      { lightness: 10 }
    ]
  },
  /* === DISABLE CLUTTER === */
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }]
  }
];

document.addEventListener("DOMContentLoaded", function () {
  initGoogleMap();

  const modalIdList = ['investment-map-modal', 'property-media-modal'];
  modalIdList.forEach(modalId => {
    const modal = document.getElementById(modalId);

    modal?.addEventListener('shown.bs.modal', function (e) {
      initGoogleMap('google-map-modal', true);
    });


    if (modal) {
      const mapTabTrigger = document.querySelector('#map-tab[data-bs-toggle="tab"]');
      mapTabTrigger?.addEventListener('shown.bs.tab', function () {
        initGoogleMap('google-map-modal', true);
      });
    }
  });

  window.addEventListener('resize', () => {
    let desktop = window.matchMedia('(min-width: 1200px)');
    const container = document.getElementById('google-map');
    const initOnMobile = container?.dataset.initOnMobile === 'true';
    if ((initOnMobile || desktop.matches) && container && !container._mapInitialized) {
      initGoogleMap();
    }
  });

});

function initGoogleMap(containerId = 'google-map', revalidateSize = false) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const initOnMobile = container.dataset.initOnMobile === 'true';
  let desktop = window.matchMedia('(min-width: 1200px)');

  if (!(initOnMobile || desktop.matches) && containerId === 'google-map') return;

  if (container._mapInitialized === true) {
    updateMarkers(containerId);

    if (revalidateSize) {
      applyBoundsWhenReady(container._googleMap);
      // setTimeout(() => google.maps.event.trigger(container._googleMap, 'resize'), 200);

      // container._googleMap.setCenter(container._googleMap.getCenter());
    }

    return;
  }

  container._mapInitialized = true;

  // Initialize map
  let map = new google.maps.Map(container, {
    center: { lat: 52.069167, lng: 19.480556 },
    zoom: 6,
    styles: MAP_STYLE_NAJM,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    disableDefaultUI: false,
  });

  container._googleMap = map;

  addMarkers(map, googleMapData.points);

}

function applyBoundsWhenReady(map) {
  if (!map._pendingBounds) return;

  google.maps.event.trigger(map, 'resize');

  google.maps.event.addListenerOnce(map, 'idle', () => {
    map.fitBounds(map._pendingBounds);
    map._pendingBounds = null;
  });
}

function addMarkers(map, points) {
  const bounds = new google.maps.LatLngBounds();
  const markers = [];

  points.forEach(point => {
    const marker = new google.maps.Marker({
      position: { lat: +point.lat, lng: +point.lng },
      map,
      title: point.name,
      icon: {
        url: '/wp-content/themes/najm/assets/google/images/marker-icon.png',
        scaledSize: new google.maps.Size(24, 24),
      }
    });

    const box = new google.maps.InfoWindow({
      content: `
        <div class="najm-google-infobox">
          <p class="h5 mb-0">${point.name}</p><br/>
          <a class="btn btn-icon btn-icon-arrow btn-primary mt-3" href="${googleMapData.popupLinkBaseUrl}${point.id}">${googleMapData.popupLinkLabel}</a>
        </div>
        `,
    });

    box.addListener('domready', () => {
      document
        .querySelectorAll('.gm-style-iw-chr button')
        .forEach(btn => { if (btn) btn.classList.add('btn-close') });
    });

    marker.addListener('click', () => box.open(map, marker));

    markers.push(marker);
    bounds.extend(marker.position);
  });

  map._markers = markers;

  if (markers.length === 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(14);
  } else {
    map._pendingBounds = bounds;
    applyBoundsWhenReady(map);
  }
}

function updateMarkers(containerId) {
  const map = document.getElementById(containerId)._googleMap;
  if (!map || !map._markers) return;

  map._markers.forEach(marker => marker.setMap(null));
  map._markers = [];

  addMarkers(map, googleMapData.points);
}
